import * as React from 'react';
import logo from '../images/logo.png';

export const jnkTop = <div className="d-flex align-items-center position-relative">
    <img className="h-3c position-absolute" src={logo} alt="百灵威" />
    <div className="h3 flex-fill text-center">
        <span className="text-primary mr-3">百灵威</span>
    </div>
</div>;
